import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, Inject, PLATFORM_ID } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { SharedCatalogState } from '@shared/state/catalog/shared-catalog.state';
import { Subject, timer } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { TakeUntilDestroy } from '@utils/auto-unsubscribe';
import { isPlatformBrowser } from '@angular/common';
import { ConnectedPosition } from "@angular/cdk/overlay";

@Component({
  selector: 'app-dynamic-update-info',
  templateUrl: './dynamic-update-info.component.html',
  styleUrls: ['./dynamic-update-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@TakeUntilDestroy
export class DynamicUpdateInfoComponent implements OnInit {
  private _sessionKey: string;
  @Input() public isMobile: boolean;
  public icons = CustomIcons;
  public componentDestroy: () => Subject<any>;
  public showDynamicInfo = false;
  public isOpen = false;
  public cdkPosition: ConnectedPosition[] = [
    {
      originX: 'end',
      overlayX: 'end',
      originY: 'top',
      overlayY: 'top'
    }
  ];
  constructor(private store: Store, private cdr: ChangeDetectorRef, @Inject(PLATFORM_ID) private platformId: string) {}

  public ngOnInit(): void {
    const currentCatalogItem = this.store.selectSnapshot(SharedCatalogState.catalogInfo);

    if (currentCatalogItem && currentCatalogItem.isDynamic && currentCatalogItem.updatePeriod) {
      this._sessionKey = currentCatalogItem.id.toString();
      const dontShowString = sessionStorage.getItem(this._sessionKey);
      if (dontShowString) {
        if (JSON.parse(dontShowString) === true) {
          return;
        }
      }

      timer(+currentCatalogItem.updatePeriod * 1000)
        .pipe(take(1), takeUntil(this.componentDestroy()))
        .subscribe(() => {
          this.showDynamicInfo = true;
          this.cdr.detectChanges();
        });
    }
    if (this.isMobile) {
      this.cdkPosition = [
        {
          originX: 'end',
          overlayX: 'end',
          originY: 'bottom',
          overlayY: 'bottom'
        }
      ];
    }
  }

  public onBackdropClick(): void {
    this.isOpen = false;
  }

  public dontShow(): void {
    if (isPlatformBrowser(this.platformId) && this._sessionKey) {
      sessionStorage.setItem(this._sessionKey, JSON.stringify(true));
      this.isOpen = false;
      this.showDynamicInfo = false;
      this.cdr.detectChanges();
    }
  }
}
